<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
  name: "TheHeader"
})
</script>

<template>
  <header v-if="false" class="hidden md:flex gap-4 px-4 md:px-16 py-4">
    <app-link :to="{ name: 'AppAboutPage' }" class="">Online Markets-ի մասին</app-link>
    <app-link :to="{ name: 'AppCooperationPage' }" class="">Համագործակցություն</app-link>
    <app-link :to="{ name: 'AppContactPage' }" class="">Հետադարձ կապ</app-link>
  </header>
</template>

<style scoped>
header {
  background-color: #ffffff;
  color: #1f1f1f;
  text-align: center;
  font-size: 0.8rem;
  font-weight: 500;
}
</style>